const PREFIX = "ss.";

function build(store: Storage) {
  return {
    get(key: string): string | null {
      return store.getItem(PREFIX + key);
    },
    set(key: string, value: string): void {
      store.setItem(PREFIX + key, value);
    },
    remove(key: string): void {
      store.removeItem(PREFIX + key);
    },
  };
}

export const local = build(window.localStorage);
export const session = build(window.sessionStorage);
